import { createClient } from "@supabase/supabase-js";
const SUPABASE_URL =  process.env.REACT_APP_SUPABASE_URL ||  "https://yweznrjxwerdaoclquzw.supabase.co/"
const SUPABASE_ANON_KEY =  process.env.REACT_APP_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl3ZXpucmp4d2VyZGFvY2xxdXp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE2OTg5MzUsImV4cCI6MjA1NzI3NDkzNX0.SiAkmR6bv8HT5dJ7kSvjYYNxtGsbaLjFi4wSnpGBJuI"

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
